import React from 'react';
import { Div, Gutter, InlineNotification, BodyText } from '@gaiads/telia-react-component-library';
import { TFunction } from 'react-i18next';

import { EditBundleSalesChannelErrorType } from './types';

interface VariantErrorNotificationsProps {
  variantErrors: EditBundleSalesChannelErrorType[];
  t: TFunction<'bundlesview', undefined>;
  countryName: string;
}

const VariantErrorNotifications = ({ variantErrors, t, countryName }: VariantErrorNotificationsProps) => {
  type ErrorListItem = {
    title: string;
    body: string;
  };
  type ErrorList = {
    [index in EditBundleSalesChannelErrorType]: ErrorListItem;
  };

  const errorTextKeys = {} as ErrorList;
  errorTextKeys[EditBundleSalesChannelErrorType.MissingMaterial] = { title: 'materialCodeMissing', body: 'materialCodeMissingLong' };
  errorTextKeys[EditBundleSalesChannelErrorType.TfapDefault] = { title: 'missingPrice', body: 'missingPriceLong' };

  return (
    <>
      {variantErrors.map((errorType, index) => (
        <Div key={variantErrors + errorType + index}>
          <Gutter size="xs" />
          <InlineNotification variant={'error'}>
            <BodyText>
              <strong>{t(`errors.${errorTextKeys[errorType].title}`)}</strong>
              <br />
              <span>{t(`errors.${errorTextKeys[errorType].body}`, { countryName })}</span>
            </BodyText>
          </InlineNotification>
          <Gutter size="md" />{' '}
        </Div>
      ))}
    </>
  );
};

export default VariantErrorNotifications;
